import { DeleteActionIconButton } from '../actions';

/**
 * @deprecated Use `import { DeleteActionIconButton } from '@/components/actions'` instead.
 */
export const DeleteIconButton = DeleteActionIconButton;
